import { styled, Typography } from "@mui/material";

export const TitleTypography = styled(Typography)<{ $isRTL?: boolean }>(({ theme, $isRTL }) => ({
  color: theme.customColors.exploreCardText,
  direction: $isRTL ? "rtl" : "ltr",
  fontSize: "1rem",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "1.3125rem",
  padding: "0rem 1rem",
  textAlign: $isRTL ? "right" : "left"
}));
